const foodData = [
    {
        id: 1,
        label: 'Chinese Rice',
        image: 'https://images.unsplash.com/photo-1630914441934-a29bf360934c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZyaWVkJTIwcmljZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=400&q=60'
    }, 
    {
        id: 2,
        label: 'Noodles',
        image: 'https://images.unsplash.com/photo-1612929633738-8fe44f7ec841?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8ZnJpZWQlMjByaWNlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=400&q=60'
    }, 
    {
        id: 3,
        label: 'Indian Rice',
        image: 'https://images.unsplash.com/photo-1626266799502-ec96e7cc4bce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fGZyaWVkJTIwcmljZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=400&q=60'
    }, 
    {
        id: 4,
        label: 'Vegetable Soup',
        image: 'https://img.freepik.com/free-photo/top-view-vegetable-soup-with-meat-inside-plate-grey_140725-36040.jpg?size=626&ext=jpg&ga=GA1.2.1434618547.1654682756'
    }, 
    {
        id: 5,
        label: 'Spaghetti with Shrimps',
        image: 'https://img.freepik.com/free-photo/pasta-spaghetti-with-shrimps-sauce_1220-5069.jpg?size=626&ext=jpg&ga=GA1.2.1434618547.1654682756'
    }, 
    {
        id: 6,
        label: 'Mexican Taco',
        image: 'https://img.freepik.com/free-photo/mexican-tacos-with-beef-tomato-sauce-salsa_2829-14218.jpg?w=740&t=st=1654684530~exp=1654685130~hmac=359e7e9f8477696a465f1b09e36c244b583b7d4d9fa154ecc71900acde917b69'
    }, 

]

export {foodData}